import React from "react";
import withContext from "app/bundles/shared/helpers/withContext";

import { useTranslation } from "react-i18next";

import "./styles.scss";
import { TechicalSupport } from "./TechnicalSupport";
import { ContactUs } from "./ContactUs";
import prisbarometerhover from "../images/prisbarometern-logo-hover.png";
import prisbarometer from "../images/prisbarometern-logo-regular.png";
import { CopyRight } from "./CopyRight";

interface IProps {
    baseUrl: string;
    href: string;
    language: "sv" | "en";
    version: string;
    address: string;
    city: string;
    feedBack: string;
    contactUs: string;
    techSupport: string;
    prisbarometerUrl: string;
    faq: string;
    share: string;
    avropsplatsenLabel: boolean;
}

const Footer = (props: IProps) => {
    const { version } = props;

    const { t } = useTranslation();

    return (
        <div className="flex flex-row justify-between items-center w-full text-[#C7C7C7] bg-[#242424]">
            <div className="flex flex-row justify-start items-center h-[40px] ">
                {props.avropsplatsenLabel ? null : (
                <a
                    href={props.prisbarometerUrl}
                    className="w-[150px] cursor-pointer mr-4"
                >
                    <img src={prisbarometer} alt="Prisbarometer" />
                </a>
                    )}
                <TechicalSupport
                    techSupport={props.techSupport}
                    faq={props.faq}
                />
                <a
                    href={props.feedBack}
                    className="cursor-pointer px-4 py-2 font-normal text-base text-[#C7C7C7] hover:text-white hover:bg-black no-underline"
                >
                    {t("Footer.sendFeedback")}
                </a>
                <ContactUs
                    address={props.address}
                    city={props.city}
                    contactUs={props.contactUs}
                />
            </div>
            <div className="flex flex-row justify-end items-center text-[#C7C7C7] bg-[#242424]">
                <div className="px-4 py-2 font-normal text-base text-[#6e6e6e]">
                    {t("Footer.version", { version })}
                </div>
                <CopyRight />
            </div>
        </div>
    );
};

export default withContext(Footer);
